import React from "react";
import { FOUNDER } from "../mock";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function FounderSection() {
  return (
    <section className="relative bg-[var(--lc-cream-soft)] py-20 lg:py-28">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-5 order-2 lg:order-1">
            <div className="eyebrow text-[var(--lc-moss)] mb-5">Meet Your Coach</div>
            <h2 className="font-serif-display text-[clamp(34px,5vw,68px)] leading-[1] font-light">
              {FOUNDER.name}
            </h2>
            <div className="mt-3 text-sm text-[var(--lc-muted)] tracking-wider uppercase">{FOUNDER.role}</div>
            <p className="mt-7 text-[15px] leading-relaxed text-[var(--lc-ink)] max-w-md">
              {FOUNDER.bio}
            </p>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 mt-9 text-[12px] font-bold tracking-[0.18em] uppercase border-b border-[var(--lc-ink)] pb-1 hover:gap-3 transition-all"
            >
              About LONGEV CIRCLE <ArrowUpRight className="h-4 w-4" />
            </Link>
          </div>
          <div className="lg:col-span-7 order-1 lg:order-2">
            <div className="relative aspect-[4/5] lg:aspect-[5/4] overflow-hidden rounded-md">
              <img
                src={FOUNDER.image}
                alt={FOUNDER.name}
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-5 left-5 bg-white/95 backdrop-blur-md px-5 py-3 rounded-sm">
                <div className="font-serif-display text-lg leading-tight">Basel · Switzerland</div>
                <div className="text-[11px] tracking-[0.18em] uppercase text-[var(--lc-muted)] mt-0.5">Founded 2025</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
